export default __webpack_public_path__ + "static/media/KjuupIcon.19e91a71.svg";